import { apiPaths } from "@/lib/api/paths";
import type { OkResponse } from "@typings/api";
import { apiClient } from "@/lib/api/client";
import type { UpdateCollarIndividualDTO } from "./type";

export async function updateCollarIndividual(
  collar: UpdateCollarIndividualDTO,
): Promise<OkResponse> {
  const response = await apiClient.patch<OkResponse>(
    apiPaths.devices.collars.updateIndividual(collar.id),
    { individualId: collar.individualId },
  );
  return response.data;
}
